import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Skeleton } from "antd";
import "./Details.css";
import HTTP from "../../services/httpService";
import { formatDate, downloadCSV, getUserRole } from "../../services/util";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";

function QualityMatricsDetails() {
    const { component: type } = useParams();
    const { state } = useLocation();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels, selectedHotelType, kioskSelection } =
        useContext(SettingContext);

    const [hotelData, setHotelData] = useState([]);
    const navigate = useNavigate();
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "count",
    });

    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const defaultFormData = {
        component_name: state.component_name,
        hotel_ids: hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        hotel_type: selectedHotelType,
        ...(selectedHotelType == "kiosk"
            ? { calling_hotel_type: kioskSelection }
            : {}),
        staff_id,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    };
    const [formData, setFormData] = useState(defaultFormData);

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
            fixed: "left",
            render: (text, record) => (
                <span
                    id={record.hotel_id}
                    style={{
                        color: record["count"] ? "#1890ff" : "black",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        navigate("/support-details-table", {
                            state: {
                                id: Number(record.hotel_id),
                                filter: true,
                                component_name: state.component_name,
                            },
                        });
                    }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: state.component,
            dataIndex: "count",
            key: "count",
            render: (text) => <p>{text}</p>,
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "count" ? sortedInfo.order : null,
        },
        {
            title: "Valid Transaction",
            dataIndex: "valid_transactions",
            key: "valid_transactions",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "valid_transactions"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Issue-to-transaction Ratio",
            dataIndex: "ratio",
            key: "ratio",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "ratio" ? sortedInfo.order : null,
        },
    ];

    const {
        status: detailStatus,
        data: detailRes,
        refetch: fetchDetails,
    } = useQuery(
        type,
        async () => {
            return await HTTP("/dashboard/getSupportTicketErrorDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchDetails();
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            hotel_type: selectedHotelType,
            ...(selectedHotelType == "kiosk"
                ? { calling_hotel_type: kioskSelection }
                : {}),
            hotel_ids: [],
            all_selected: true,
            page: 0,
        });
        setCurrentPage(1);
    }, [selectedHotelType]);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        fetchDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (detailStatus === "success") {
            const { data, total } = detailRes;
            setHotelData(data);
            setTotalRecords(total);
        }
    }, [detailStatus, detailRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
        setCurrentPage(current);
    }

    async function downloadReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getDashboardDataReport", {
            ...tempFormData,
        });

        downloadCSV(res, `${state.component_name}_issue_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downloadReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {!hotelData.length ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={hotelData}
                        currentPage={currentPage}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </Card>
    );
}

export { QualityMatricsDetails };
